import React from "react";
import {motion} from "framer-motion";
import {MailPlus, CheckCircle} from "lucide-react";

export const CreateInviteModal = ({form, formLoading, onClose, onChange, onSubmit}) => {
    return (
        <motion.div
            className="fixed inset-0 z-[1000] bg-black bg-opacity-40 flex items-center justify-center px-fluid-2"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
        >
            <motion.div
                className="bg-white rounded-2xl shadow-xl w-full max-w-md p-fluid-3 space-y-fluid-3"
                initial={{scale: 0.95}}
                animate={{scale: 1}}
                exit={{scale: 0.95}}
            >
                {/* Header */}
                <div className="flex flex-col items-center space-y-fluid-1.5">
                    <div className="bg-[#1e2a74] rounded-full p-fluid-2 text-white">
                        <MailPlus size={28}/>
                    </div>
                    <h2 className="text-fluid-xl font-semibold text-[#111827]">
                        Create New Invitation
                    </h2>
                    <p className="text-fluid-base text-gray-600 text-center">
                        Set invite validity and recipient email
                    </p>
                </div>

                {/* Form Fields */}
                <form onSubmit={onSubmit} className="space-y-fluid-2 text-fluid-sm text-gray-800">
                    <div>
                        <label className="block font-medium mb-1">Valid Days *</label>
                        <input
                            type="number"
                            min={1}
                            max={365}
                            required
                            value={form.days}
                            onChange={(e) => onChange("days", e.target.value)}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>
                    <div>
                        <label className="block font-medium mb-1">Email *</label>
                        <input
                            type="email"
                            required
                            value={form.email}
                            onChange={(e) => onChange("email", e.target.value)}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>
                    <div>
                        <label className="block font-medium mb-1">SCAC Code *</label>
                        <input
                            type="text"
                            required
                            placeholder="Enter SCAC Code"
                            value={form.scacCode || ""}
                            onChange={(e) => onChange("scacCode", e.target.value.toUpperCase())}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>
                    <div>
                        <label className="block font-medium mb-1">Organization Type *</label>
                        <select
                            required
                            value={form.inviteType || ""}
                            onChange={(e) => onChange("inviteType", e.target.value)}
                            className="w-full border rounded px-3 py-2"
                        >
                            <option value="" disabled>Choose organization type</option>
                            <option value="Shipper">Shipper</option>
                            <option value="Carrier">Carrier</option>
                        </select>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex justify-end gap-fluid-2 pt-fluid-2 border-t border-gray-200">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-fluid-button-x py-fluid-button-y border border-gray-300 rounded text-gray-700 hover:bg-gray-100 text-fluid-sm transition"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-fluid-button-x py-fluid-button-y bg-[#1e2a74] text-white hover:bg-[#18225c] text-fluid-sm rounded font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={formLoading}
                        >
                            {formLoading ? "Creating..." : "Submit"}
                        </button>
                    </div>
                </form>
            </motion.div>
        </motion.div>
    );

};

export const CopyToast = ({message}) => (
    <motion.div
        className="fixed bottom-8 right-8 bg-green-600 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center gap-2"
        initial={{opacity: 0, y: 20}}
        animate={{opacity: 1, y: 0}}
        exit={{opacity: 0, y: 20}}
        transition={{duration: 0.3}}
    >
        <CheckCircle size={20} className="text-white"/>
        <span className="text-sm font-medium">{message}</span>
    </motion.div>
);